import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["BtnContent"] */ "/app/src/app/(pages)/home/components/new/BusinessSection/BtnContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BtnBlock"] */ "/app/src/app/(pages)/home/components/new/News/BtnBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/new/News/NewsSection.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["FaqAccordion"] */ "/app/src/app/(pages)/home/components/new/SupportFAQ/FaqAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BannerLeft"] */ "/app/src/app/(pages)/home/components/new/TopSection/BannerLeft.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnlineServiceCard"] */ "/app/src/app/(pages)/home/components/OnlineServicesSection/OnlineServiceCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OnlineServicesHeader"] */ "/app/src/app/(pages)/home/components/OnlineServicesSection/OnlineServicesHeader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/OnlineServicesSection/OnlineServicesSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/BenefitsSteps/BenefitsSteps.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/Services/Services.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/new/SupportFAQ/SupportFAQ.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/new/BusinessSection/BusinessSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/new/TopSection/TopSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/ServicesSection/ServicesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CalculatorForm"] */ "/app/src/app/(pages)/home/components/TrackAndCalculate/CalculatorForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/home/components/TrackAndCalculate/TrackAndCalculate.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["TrackingForm"] */ "/app/src/app/(pages)/home/components/TrackAndCalculate/TrackingForm.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/(pages)/news/components/MainNews.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/features/Form/CTABenefits.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["CTAForm"] */ "/app/src/components/features/Form/CTAForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MotionWrapper"] */ "/app/src/components/features/Form/MotionWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/features/TelegramSubscribe/TelegramSubscribe.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/features/Form/CTASection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/features/ParcelTrackingForm/ParcelTrackingForm.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/PageLayout/Section.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/BadgeWithIcon/BadgeWithIcon.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/DecorativeSquare/DecorativeSquare.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/DecorativeSquare/DecorativePattern.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/Icon/IconReact.tsx");
